import React, { useState } from "react";
import { toast } from "react-toastify";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import { i18n } from "../../translate/i18n";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { validateCancelReason, buildCancelTaskPayload } from "../../pages/Tasks/taskUtils";

// Diálogo de confirmação para cancelar a tarefa — motivo obrigatório
// (mín. 3, máx. 255). É um estado final: a confirmação é explícita e o
// texto deixa isso claro. Bloqueia ESC/clique fora e duplo envio.
const TaskCancelDialog = ({ open, onClose, onConfirm }) => {
  const [cancelReason, setCancelReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [fieldError, setFieldError] = useState(null);

  const handleClose = () => {
    if (saving) return;
    onClose();
  };

  const handleConfirm = async () => {
    const error = validateCancelReason(cancelReason);
    if (error) {
      setFieldError(error);
      return;
    }

    setSaving(true);
    const payload = buildCancelTaskPayload({ cancelReason });
    const success = await onConfirm(payload);
    setSaving(false);

    if (success) {
      toast.success(i18n.t("tasks.details.actions.cancelSuccess"));
      setCancelReason("");
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="task-cancel-dialog-title"
      disableBackdropClick={saving}
      disableEscapeKeyDown={saving}
    >
      <DialogTitle id="task-cancel-dialog-title">
        {i18n.t("tasks.details.actions.cancelTitle")}
      </DialogTitle>
      <DialogContent dividers>
        <Typography color="error" gutterBottom>
          {i18n.t("tasks.details.actions.cancelWarning")}
        </Typography>
        <TextField
          label={i18n.t("tasks.details.actions.cancelReason")}
          variant="outlined"
          size="small"
          fullWidth
          required
          multiline
          minRows={2}
          value={cancelReason}
          onChange={e => {
            setCancelReason(e.target.value);
            setFieldError(null);
          }}
          error={Boolean(fieldError)}
          helperText={fieldError ? i18n.t(`tasks.details.actions.errors.cancelReason.${fieldError}`) : ""}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving} color="secondary" variant="outlined">
          {i18n.t("tasks.details.actions.keepButton")}
        </Button>
        <ButtonWithSpinner onClick={handleConfirm} color="secondary" variant="contained" loading={saving}>
          {i18n.t("tasks.details.actions.cancelConfirmButton")}
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default TaskCancelDialog;
